import $ from 'jquery';

export const handlerVkShareBtn = () => {
    if(typeof VK === 'undefined'){
        return;
    }

    const btn = $('#vkShareBtn');
    const url = btn.attr('href');
    const classes = btn.attr('class');

    btn.replaceWith(VK.Share.button(
        {
            url: url,
        },
        {
            type: 'custom',
            text: '<div class="' + classes + '" style="margin-right: 25px;"></div>',
        }
    ));
};
